import type { Percentage } from "@@/shared/percentage";
import { priceFactory, type Price } from "./price";

const percentageOfPrice = (price: Price, percentage: Percentage): Price => {
    return priceFactory({
        currencyCode: price.currencyCode,
        tags: price.tags,
        vat: price.vat,
        amountIncludingVat: price.amountIncludingVat * percentage,
    });
};

export { percentageOfPrice };
